import React, {useEffect, useState} from "react";
import { Checkbox as AntCheckbox } from 'antd';
import {convertToOptions} from "../../../utils/arrayObjectHelper";

const componentClass = 'fieldType__checkbox';

const Checkbox = ({ onChange, options, shouldConvertOptions, useStringify, value, ...rest }) => {
  const optionsToUse = shouldConvertOptions ? convertToOptions(options) : options;
  const isMultipleOptions = (optionsToUse || []).length > 1;
  const parseValue = v => v && isMultipleOptions
      ? useStringify ? JSON.parse(v) : v //if using multiple checkboxes, value should either be JSON or an array
      : v ? [v.toString()] : []; //otherwise, one checkbox value should be string or number

  const [checkedValues, setCheckedValues] = useState(parseValue(value));
  useEffect(() => { setCheckedValues(parseValue(value)) }, [value]);

  const onValueChange = (isChecked, value) => {
    const newCheckedValues = isChecked ? [...(checkedValues || []), value] : checkedValues.filter(v => v !== value);
    let valueToReturn;
    if (isMultipleOptions) {
      valueToReturn = useStringify ? JSON.stringify(newCheckedValues) : newCheckedValues;
    } else {
      valueToReturn = isChecked ? value : null;
    }
    setCheckedValues(newCheckedValues);
    onChange && onChange(valueToReturn);
  };

  const isBoxChecked = v => {
    return checkedValues.includes(v);
  }

  const renderCheckboxes = () => {
    return (optionsToUse || []).map(o => {
      const optionValue = o.value || o.label;
      return <AntCheckbox checked={isBoxChecked(optionValue)} onChange={e => onValueChange(e.target.checked, optionValue)}>
        { o.label || o.value }
      </AntCheckbox>
    })
  };

  return <div className={componentClass}>
    { renderCheckboxes() }
  </div>;
};

export default Checkbox;
